module.exports = __webpack_public_path__ + "img/1.1b59a81d.png";